import './App.scss';
import { FC, useEffect, useState, Fragment } from 'react';
import axios from 'axios';
import { ContentContainer, ContentItem } from './GlobalTypes';
import Loader from './components/Loader/Loader';
import { Header, Footer } from './components/PageFraming';
import Login from './components/Login/Login';
import VoteContainer from './components/VoteContainer/VoteContainer';

const App: FC = () => {
	const [initialLoad, setInitialLoad] = useState(true);
	const [loading, setLoading] = useState(false);
	const [loginRequired, setLoginRequired] = useState(false);
	const [content, setContent] = useState<ContentContainer|null>();
	const [currentVote, setCurrentVote] = useState<ContentItem|null>(null);

	const findByContentId = (content_id: number) => {
		let matchedChild = null;
		content?.children.forEach(child => {
			if (child.id === content_id) {
				matchedChild = child;
				return matchedChild;
			}
		});
		return matchedChild;
	}

	useEffect(() => {
		let query = window.location.search.substring(1);
		let vars = query.split('&');
		let contentId = 0;
		for(let i = 0; i < vars.length; i++) {
			let x = vars[i].split('=');
			if (x[0] === 'content') {
				contentId = parseInt(x[1]);
			}
		}
		if (contentId === 0) {
			return;
		}
		if (!initialLoad) {
			return;
		}

		axios.get(`${process.env.REACT_APP_API_ENDPOINT}?content=${contentId}`, {withCredentials: true})
			.then(response => {
				let cont = response.data.content;
				setContent(cont);
				cont.children?.forEach((child: ContentItem) => {
					if (child.id === response.data.existing_vote) {
						setCurrentVote(child);
					}
				});
				setInitialLoad(false);
			})
			.catch((error) => {
				if (error && error.response && error.response.status === 401) {
					if (error.response.data.error === 'Login required') {
						setLoginRequired(true);
					}
				}
				setInitialLoad(false);
				setContent(null);
			});
	}, [initialLoad]);


	const loginEvent = () => {
		if (content) {
			return;
		}
		setInitialLoad(true);
		setLoginRequired(false);
	}

	const executeVoteHandler = (content_id: number) => {
		setLoading(true);
		let bodyFormData = new FormData();
		bodyFormData.append('vote_content_id', content_id.toString());
		axios.post(`${process.env.REACT_APP_API_ENDPOINT}?content=22024`,bodyFormData,{withCredentials: true})
			.then(() => {
				setCurrentVote(findByContentId(content_id));
				setLoading(false);
			})
			.catch((error) => {
				setLoading(false);
			})
	}

	//Use a fullscreen loader while the content is fetching
	if (initialLoad) {
		return <Loader initial={true} />
	}

	const getContents = () => {
		if (content) {
			return (
				<Fragment>
					<div className="container bg-alternate-2">
						<div className="content-wrapper">
							<h1>Click on your favourite film to register your vote</h1>
						</div>
					</div>
					<div className="container bg-alternate-2">
						<div className="content-wrapper">
							<VoteContainer  children={content.children} currentVote={currentVote} voteClickCallback={executeVoteHandler} />
						</div>
					</div>
				</Fragment>
			);
		} else if (loginRequired) {
			return (
				<Fragment>
					<div className="container bg-alternate-1">
						<div className="content-wrapper">
							<Login loginCallback={loginEvent} />
						</div>
					</div>
				</Fragment>
			)
		} else {
			return (
				<Fragment>
					<div className="container bg-alternate-1">
						<div className="content-wrapper">
							<h2>Sorry, you're not able to vote in this contest</h2>
							<p>It looks like you don't have a ticket for this content</p>
						</div>
					</div>
				</Fragment>
			)
		}
	}

	return (
		<div className="page-wrapper">
			{ loading ? <Loader initial={false} /> : null}
			<div className="container">
				<Header />
			</div>
			{getContents()}
			<div className="container">
				<Footer />
			</div>
		</div>
	);
}

export default App;
